import { render, staticRenderFns } from "./userSpectaculars.vue?vue&type=template&id=5c6e91db&scoped=true&"
import script from "./userSpectaculars.vue?vue&type=script&lang=js&"
export * from "./userSpectaculars.vue?vue&type=script&lang=js&"
import style0 from "./userSpectaculars.vue?vue&type=style&index=0&id=5c6e91db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e91db",
  null
  
)

export default component.exports